import {DropDownList} from "@progress/kendo-react-dropdowns";
import {Button} from "@progress/kendo-react-buttons";
import {filterBy} from "@progress/kendo-data-query";
import {useState} from "react";
import {DatePicker} from "@progress/kendo-react-dateinputs";



const DateFilter = props => {

    const textField = "Name"
    const filterable = props.filterable || false
    const field = props.field

    let currentFilters = { ...props.dataState.filter }

    let actualFrom, actualTo
    if (currentFilters.filters) {
        actualFrom = currentFilters.filters.find(function (f) {
            return f.field === field && f.operator === "gte"
        })
        actualTo = currentFilters.filters.find(function (f) {
            return f.field === field && f.operator === "lte"
        })
    }
    const now = new Date()

    actualFrom = actualFrom ? actualFrom.value : now
    actualTo = actualTo ? actualTo.value : now

    console.log("Actuals /// ", actualFrom, actualTo)

    // debugger

    let DateData = []
    const filterType = props.type
    const currentDate = new Date()

    switch (filterType) {
        case "past":

            const ThisMonthS = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const ThisMonthE = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

            const LastMonthS = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const LastMonthE = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

            const ThisAndLastMonthS = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
            const ThisAndLastMonthE = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

            const ThisYearS = new Date(currentDate.getFullYear(), 0, 1);
            const ThisYearE = new Date(currentDate.getFullYear(), 11, 31);

            const LastYearS = new Date(currentDate.getFullYear() -1, 0, 1);
            const LastYearE = new Date(currentDate.getFullYear() -1, 11, 31);

            console.log("nastavene /// ", ThisYearS)

            DateData = [
                {ID:2, Name: "This month", From:ThisMonthS, To:ThisMonthE},
                {ID:1, Name: "Last month", From:LastMonthS, To:LastMonthE},
                {ID:5, Name: "This & Last month", From:ThisAndLastMonthS, To:ThisAndLastMonthE},
                {ID:3, Name: "This year", From:ThisYearS, To:ThisYearE},
                {ID:4, Name: "Last year", From:LastYearS, To:LastYearE}
            ]
            break

        case "future":
            const f_ThisMonthS = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const f_ThisMonthE = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

            const f_NextMonthS = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
            const f_NextMonthE = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0);

            const f_ThisYearS = new Date(currentDate.getFullYear(), 0, 1);
            const f_ThisYearE = new Date(currentDate.getFullYear(), 11, 31);

            const f_NextYearS = new Date(currentDate.getFullYear() +1, 0, 1);
            const f_NextYearE = new Date(currentDate.getFullYear() +1, 11, 31);


            DateData = [
                {ID:2, Name: "This month", From:f_ThisMonthS, To:f_ThisMonthE},
                {ID:1, Name: "Last month", From:f_NextMonthS, To:f_NextMonthE},
                {ID:3, Name: "This year", From:f_ThisYearS, To:f_ThisYearE},
                {ID:4, Name: "Last year", From:f_NextYearS, To:f_NextYearE}
            ]
            break

        default:
            DateData = props.data

    }


    let hasValue = (value) => Boolean(value && value !== props.defaultItem);
    // debugger
    const onChange = (event) => {

        hasValue = hasValue(event.target.value);

        let currentFilters = { ...props.dataState.filter }

        //TODO: Dodelat pro datum do

        // Filter from
        if (currentFilters.filters) {
            let newFilter = currentFilters.filters.filter((filter) => {
                return !(
                    filter.field === field // && // Smaze vsechny filtery na dane pole
                    // filter.operator === "gte"
                );
            });
            currentFilters.filters = newFilter;
            currentFilters.filters.push({
                field: field,
                operator: "gte",
                value: event.target.value.From,
            });
            currentFilters.filters.push({
                field: field,
                operator: "lte",
                value: event.target.value.To,
            });
        } else {
            currentFilters.filters = [];
            currentFilters.logic = "and";
            currentFilters.filters.push({
                field: field,
                operator: "gte",
                value: event.target.value.From,
            });
            currentFilters.filters.push({
                field: field,
                operator: "lte",
                value: event.target.value.To,
            });
        }


        props.setDataState({...props.dataState, filter: currentFilters});
        console.log(props.dataState)

        //TODO: https://www.telerik.com/kendo-react-ui/components/knowledge-base/grid-date-ragne-filter/

    };


    const onClearButtonClick = (event) => {
        let currentFilters = { ...props.dataState.filter };
        let newFilter = currentFilters.filters.filter((filter) => {
            return filter.field !== field;
        });
        currentFilters.filters = newFilter;
        props.setDataState({...props.dataState, filter: currentFilters });
    };

    const [data, setData] = useState(DateData.slice());
    //
    // const filterData = (filter) => {
    //     const data = DateData.slice();
    //     return filterBy(data, filter);
    // };
    // const filterChange = (event) => {
    //     setData(filterData(event.filter));
    // };

    return (
        <>

            <div className="k-filtercell">
                <DropDownList
                    data={data}
                    onChange={onChange}
                    value={DateData.find((c) => c.From.getTime() === actualFrom.getTime() && c.To.getTime() === actualTo.getTime()) || props.defaultItem}
                    // defaultItem={props.defaultItem}
                    textField={"Name"}
                    filterable={filterable}
                    // onFilterChange={filterChange}
                    //dataItemKey="ID"
                />

                <Button
                    title="Clear"

                    themeColor={hasValue(props.value) ? "error" : "base" }
                    disabled={!hasValue(props.value)}
                    onClick={onClearButtonClick}
                    icon="filter-clear"
                />
            </div>

        </>
    )
}

export default DateFilter